import isEmpty from 'lodash/isEmpty'
import { useEffect, useRef } from 'react'
import type { UIMessage } from 'ai'
import { Stack } from 'react-bootstrap'
import { MessageBubble } from './MessageBubble'
import { EmptyChat } from './EmptyChat'

export type MessageListProps = {
  /** Array of messages to display */
  messages: UIMessage[]
}

/**
 * MessageList component renders the conversation history.
 * Automatically scrolls to the latest message when new messages arrive.
 */
export const MessageList = ({ messages }: MessageListProps) => {
  const bottomRef = useRef<HTMLDivElement>(null)

  // Auto-scroll to bottom when new messages arrive
  useEffect(() => {
    if (bottomRef.current) {
      bottomRef.current.scrollIntoView({ behavior: 'smooth' })
    }
  }, [messages])

  // Show empty state when no messages
  if (isEmpty(messages)) {
    return <EmptyChat />
  }

  return (
    <Stack gap={0} className="flex-grow-1">
      {messages.map((message) => (
        <MessageBubble key={message.id} message={message} />
      ))}
      {/* Invisible element to scroll to */}
      <div ref={bottomRef} />
    </Stack>
  )
}
